module.exports = __webpack_public_path__ + "static/media/icon-filter-lines-black.8cec7e3c.svg";